import styled from 'styled-components'

export const GenericHideChildrenOnPrintWrapper = styled.div`
  @media print {
    display: none !important;
  }
`
